import React, { useState } from 'react';
import { apiService } from '../services/apiService';
import { BaseForm, createEmailField } from './BaseForm';
import { KairosBrand } from './KairosBrand';
import './Auth.css';

interface ForgotPasswordFormProps {
  onBackToLogin: () => void;
  showHeader?: boolean;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBackToLogin, showHeader = true }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = async (formData: Record<string, string>) => {
    try {
      await apiService.forgotPassword(formData.email);
      setMessage('If an account with that email exists, we\'ve sent you a password reset link.');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to send reset email';
      throw new Error(errorMessage);
    }
  };

  const fields = [
    createEmailField('email', 'Email', true, 'Enter your email address')
  ];

  const formContent = (
    <div className="auth-form-container">
      <BaseForm
        title="Reset Password"
        subtitle="Enter your email address and we'll send you a link to reset your password."
        fields={fields}
        onSubmit={handleSubmit}
        submitButtonText="Send Reset Link"
        showHeader={false}
        success={message}
        className="forgot-password-form"
      >
        <div className="text-center mt-4">
          <button 
            onClick={onBackToLogin}
            className="text-sm text-primary-600 hover:text-primary-500 cursor-pointer transition-all duration-300 bg-transparent border-none p-2 rounded-md hover:bg-primary-50"
          >
            Back to Login
          </button>
        </div>
      </BaseForm>
    </div>
  );

  if (showHeader) {
    return (
      <div className="auth-container">
        <div className="auth-header">
          <KairosBrand 
            showLogo={true}
            logoClassName="h-72 w-auto"
            kairosClassName="cursor-pointer hover:opacity-80 transition-opacity"
          />
        </div>
        {formContent}
      </div>
    );
  }

  return formContent;
};